module.exports = __webpack_public_path__ + "img/705.68bc842c.jpg";